import React, { useState } from "react";
// import { NoteContext } from "./noteContext";
import { GameContext } from "./noteContext";
const NoteState = (props) => {
  const [isRejected, setIsRejected] = useState(true);
  const [gameValue, setGameValue] = useState(false);
  const value = { isRejected, setIsRejected, gameValue, setGameValue };
  return (
    <GameContext.Provider value={value}>{props.children}</GameContext.Provider>
  );
};

export default NoteState;
